import { render } from "./AdContentSourcesBlock.vue?vue&type=template&id=5b9e14ac"
import script from "./AdContentSourcesBlock.vue?vue&type=script&lang=js"
export * from "./AdContentSourcesBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AdContentSourcesBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9e14ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9e14ac', __exports__)) {
    api.reload('5b9e14ac', __exports__)
  }
  
  module.hot.accept("./AdContentSourcesBlock.vue?vue&type=template&id=5b9e14ac", () => {
    api.rerender('5b9e14ac', render)
  })

}


export default __exports__